export default __webpack_public_path__ + "media/images/fonts/Flaticon-2333fb9e634f29907e0967eafdd7d011.ttf";